import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';

class MyPopover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: props.width ? props.width : 150,
            clientX: 0,
            clientY:0,
            content: props.content,
            showPopper: false,
        };

    }
    componentDidMount() {
        this.element = ReactDOM.findDOMNode(this);
        this.reference = ReactDOM.findDOMNode(this.refs.reference);
        const { trigger } = this.props;
        
        if (this.reference === null) return;

        if (trigger === 'click') {
            this.reference.addEventListener('click', (e) => {
                const _dom = this.element.getBoundingClientRect();
                let clientX = _dom.x ? parseInt(_dom.x) - (this.state.width * 2) + (_dom.width / 2) : 0;
                this.setState({
                showPopper: !this.state.showPopper,
                clientX: clientX,
                clientY: parseInt(e.layerY)+20 || parseInt(_dom.y) - 40,
                });
            
            });
            document.addEventListener('click', (e) => {
                if (!this.element || this.element.contains(e.target) ||
                    !this.reference || this.reference.contains(e.target)) return;

                this.setState({
                    showPopper: false
                });
            });
        }  else if (trigger === 'hover') {
            this.reference.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
            this.reference.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      
            // popper.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
            // popper.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
        }
    }
    
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        // console.log(props)
        this.setState({
            width: props.width ? props.width : 150,
            content: props.content
        })

    }
    sure = () => {
        this.props.sureDailog()
    }
    handleMouseEnter(){
        clearTimeout(this.timer);

        this.setState({
            showPopper: true
        });
    }

    handleMouseLeave() {
        this.timer = setTimeout(() => {
            this.setState({
                showPopper: false
            });
        }, 200);
    }

    render() {
        const { width, clientX, clientY,content } = this.state;
        let elems =
            this.state.showPopper ?
              <div className='m-popover' style={{ top: 30, right: -30 }}>
                    {content}
                    <div className="popper__arrow" ></div>
                </div> 
                : null
        return (
            <span style={{position: 'relative'}}>
                {elems}
                { React.cloneElement(React.Children.only(this.props.children), { ref: 'reference' }) }
            </span>
            
            
        );
    }
}

export default MyPopover;



// WEBPACK FOOTER //
// ./src/components/popover/index.jsx